import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, Paper, Theme, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import IconButton from 'components/common/IconButton';
import CircularTimer from 'components/common/CircularTimer';
import SurveySuccessIcon from 'components/svg/SurveySuccess.svg';

interface SurveySuccessBannerProps {
  position?: string;
  top?: number;
  marginLeft?: number;
  onClose: () => void;
  left?: string;
  transform?: string;
  width?: string | number;
  minWidth?: string | number;
}

interface StyleProps {
  top?: number;
  marginLeft?: number;
  position?: string;
  left?: string;
  transform?: string;
  width?: string | number;
  minWidth?: string | number;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const useStyles = makeStyles<StyleProps>()((theme: Theme, params) => ({
  root: {
    position: params?.position || 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    ...(params?.top && { top: params.top }),
    ...(params?.width && { width: params.width }),
    minWidth: params?.minWidth || 622,
    ...(params?.left && { left: params.left }),
    ...(params?.transform && { transform: params.transform }),
    // ...(params?.marginLeft && { marginLeft: params.marginLeft }),
    // marginRight: 64,
    padding: theme.spacing(2, 10, 2, 5.75),

    [theme.breakpoints.down('md')]: {
      // ...(params?.marginLeft && { marginLeft: 4 }),
      // marginRight: 4,
      minWidth: '90%',
      maxWidth: '90%',
      zIndex: 1000,
    },
    [theme.breakpoints.down('sm')]: {
      // ...(params?.marginLeft && { marginLeft: 4 }),
      // marginRight: 4,
      padding: '32px 32px 40px 32px',
    },

    borderRadius: 16,
    boxShadow: '0px 8px 32px rgba(56, 60, 68, 0.16)',
    zIndex: 300,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
  },
  progress: {
    position: 'absolute',
    right: theme.spacing(2.5),
    bottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      right: theme.spacing(2.5),
      bottom: theme.spacing(2),
    },
  },
  textCenter: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      fontSize: 24,
      fontWeight: 700,
    },
  },
}));

const SurveySuccessBanner: React.FC<React.PropsWithChildren<SurveySuccessBannerProps>> = (props) => {
  const { onClose, ...rest } = props;
  const { classes } = useStyles({ ...rest });
  const isSmallMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const [timer, setTimer] = useState(4);
  // const [t] = useTranslation('user');

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((timer) => {
        if (timer > -1) return timer - 1;
        return timer;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (timer === -1) {
      onClose();
    }
  }, [timer, onClose]);

  return (
    <Paper
      id="survey-succes-banner"
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      className={classes.root}
    >
      <Grid container spacing={3} alignItems="center">
        <Grid
          item
          {...(isSmallMobile && {
            xs: 12,
            display: 'flex',
            justifyContent: 'center',
            style: { paddingLeft: 64 },
          })}
        >
          <SurveySuccessIcon />
        </Grid>
        <Grid item xs>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography
                variant="h5"
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                className={classes.textCenter}
              >
                Great job!
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ ...(isSmallMobile && { textAlign: 'center' }) }} variant="body1">
                Thanks for your feedback,
                <br /> It really means a lot to us.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <IconButton
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.closeButton}
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
        <CircularTimer
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.progress}
          label={timer + 1}
          size={20}
          value={Math.ceil(timer * 20)}
        />
      </Grid>
    </Paper>
  );
};

export default SurveySuccessBanner;
